import { render, staticRenderFns } from "./BoxCreationCard.vue?vue&type=template&id=c2e491a4&"
import script from "./BoxCreationCard.vue?vue&type=script&lang=js&"
export * from "./BoxCreationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports